/**
 * `/merchandising/styles/$styleId/timeline` — Time & Action, one of the
 * Style File's 7 process screens (garment Increment 4, M2).
 *
 * @see docs/product/garment-os-screen-build-plan.md §A
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { StyleTimelinePage } from "../../../../features/styles/index.ts";

export const Route = createFileRoute("/(workspace)/merchandising/styles/$styleId/timeline")({
  component: StyleTimelineRoute,
});

function StyleTimelineRoute() {
  const { styleId } = Route.useParams();
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Merchandising", to: "/" },
        { label: "Style files", to: "/merchandising/styles" },
        { label: "Time & Action" },
      ]}
      contentClassName="max-w-none"
      viewportClassName="p-0 md:p-0"
    >
      <StyleTimelinePage styleId={styleId} />
    </WorkspaceShell>
  );
}
